import React from 'react';

import { getAdvancedSettings } from '../advancedSettings';

import type { HeadingType } from './headingConfigAggregator';

type PageBuilderHeadingProps = HeadingType;

/**
 * Return the PB Heading
 * @param props
 * @constructor
 */
export function PageBuilderHeading(props: PageBuilderHeadingProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderHeadingProps>(props);

    const headingClassNames = ['pageBuilderHeadingGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        headingClassNames.push(...props.cssClasses);
    }

    const HeadingType = props.headingType as keyof JSX.IntrinsicElements;

    /**
     * Render the Heading Block UI
     */
    return (
        <HeadingType
            data-content-type={props.contentType}
            data-pb-style={props.uniqueID}
            style={{
                ...advancedSettings,
            }}
            className={headingClassNames.join(' ')}
        >
            {props.text}
        </HeadingType>
    );
}
